// extracted by mini-css-extract-plugin
export var cookiesSection = "fj_KL";
export var cookiesSection__btn = "fj_KP";
export var cookiesSection__link = "fj_KN";
export var cookiesSection__text = "fj_KM";
export var cookiesSection__wrapper = "fj_KK";